import axios from 'axios';
import { consultSummaryTypes } from '../widgets/const';

const API_URL = process.env.REACT_APP_API_ENDPOINT;



export const fetchConsultSummariesForEpisodeOfCare = (episode_of_care_id) => {
     if(episode_of_care_id === undefined){
        return new Promise((resolve, reject) => {
            resolve([]);
        })
    }
    return axios
        .post(`${API_URL}/EpisodeOfCareController/get_consult_summaries_for_episode_of_care`, {
            episode_of_care_id: episode_of_care_id,
        })
        .then((r) => r.data);
};

export const fetchSummaryForEpisodeOfCare = (episode_of_care_id) => {
    if(episode_of_care_id === undefined){
        return new Promise((resolve, reject) => {
            resolve({});
        })
    }
    return axios
        .post(`${API_URL}/EpisodeOfCareController/get_episode_of_care_summary`, {
            episode_of_care_id: episode_of_care_id,
        })
        .then((r) => r.data);
};

export const getConsultSummaryForConsult = (consult) => {
    if(consultSummaryTypes.includes(consult.consult_type) === false || consult.consult_status !== 'completed'){
        return new Promise((resolve, reject) => {
            resolve(null);
        })
    }
    return axios
        .post(`${API_URL}/EpisodeOfCareController/get_consult_summary`, {
            consult_id: consult.consult_id,
        })
        .then((r) => r.data);
};

export const approveSummary = (consult_id, approved_summary) => {
    return axios
        .post(`${API_URL}/EpisodeOfCareController/approve_consult_summary`, {
            consult_id: consult_id,
            approved_summary: approved_summary
        })
        .then((r) => r.data);
};
